import React, { useState } from "react";
import { mirage } from 'ldrs'


export default function LoaderAdmin( {loggedData} ) {
const [error, setError] = useState(false)
    
setTimeout(() => {
    if(loggedData === null) {
      setError(true)
    }
  }, 3000);
    mirage.register()
  return (
    <div className="loaderCont">  
      <l-mirage
      size="60"
      speed="2.5" 
      color="black" 
    ></l-mirage>

    {error ? <p className="title"> No estás autorizado. <br /> Redirigite a la página de login. </p>: <></>}
    </div> 
  )
}
